import { useTranslation } from 'react-i18next';

import Pagination from 'components/stateless/Pagination/Pagination';
import TableBody from 'components/stateless/Table/TableBody';
import TableBorder from 'components/stateless/Table/TableBorder';
import TableHeader from 'components/stateless/Table/TableHeader';
import type { HeaderType } from 'components/stateless/Table/TableHeader';
import Td from 'components/stateless/Table/Td';
import TdLink from 'components/stateless/Table/TdLink';
import Tr from 'components/stateless/Table/Tr';
import { SectionTitle } from 'components/stateless/Title/SectionTitle';
import { ROUTES_FI } from 'constants/routes/financier';
import type { PageableType } from 'hooks/usePageable';
import type { AnchorAgreementVOModel } from 'models/vo/AnchorAgreementVO';

interface FinancierManageAnchorUserDetailAnchorAgreementListProps {
  anchorAgreementList: AnchorAgreementVOModel[] | undefined;
  paginate(pageNumber: number, rowCount: number): Promise<void>;
  pageable: PageableType;
}

const FinancierManageAnchorUserDetailAnchorAgreementList = ({
  anchorAgreementList,
  paginate,
  pageable,
}: FinancierManageAnchorUserDetailAnchorAgreementListProps) => {
  const { t } = useTranslation();

  const ANCHOR_AGREEMENT_TABLE_HEADERS: HeaderType[] = [
    {
      headerText: t('text:Anchor_Name'),
      colWidths: 120,
    },
    {
      headerText: t('text:Anchor_Master_Agreement_Number'),
      colWidths: 100,
    },
    {
      headerText: t('text:Currency'),
      colWidths: 96,
    },
    {
      headerText: t('text:Effective_Date'),
      colWidths: 120,
    },
    {
      headerText: t('text:Expiration_Date'),
      colWidths: 120,
    },
    {
      headerText: '',
      colWidths: 45,
    },
  ];

  return (
    <div className="content-area">
      <SectionTitle title={t('text:Associated_Anchor_Master_Agreement_List')} />
      <TableBorder>
        <TableHeader header={ANCHOR_AGREEMENT_TABLE_HEADERS} />
        <TableBody numOfCol={ANCHOR_AGREEMENT_TABLE_HEADERS.length}>
          {anchorAgreementList?.map((item, i) => {
            return (
              <Tr key={i}>
                <Td data={item.financierClientName} />
                <Td data={item.contractNo} />
                <Td data={item.currencyType} />
                <Td data={item.startDate} format="date" />
                <Td data={item.expiryDate} format="date" />
                <TdLink
                  path={ROUTES_FI.MANAGE_ANCHOR.AGREEMENT_REGISTERED_DETAIL_BUILD_PATH(item.anchorAgreementId)}
                  state={{
                    supportedCollateralType: item.collateralType,
                  }}
                />
              </Tr>
            );
          })}
        </TableBody>
      </TableBorder>
      <Pagination pageable={pageable} paginate={paginate} />
    </div>
  );
};

export default FinancierManageAnchorUserDetailAnchorAgreementList;
